// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__72fy_","left":"InfoRow_left__20E5d"};